/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Nothing_To_DragInputs */



/**
* | output |
* | --- |
* | "Nothing to drag" |
*
* @param {Spaces_Nothing_To_DragInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_nothing_to_drag = /** @type {((inputs?: Spaces_Nothing_To_DragInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Nothing_To_DragInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nichts zum Ziehen")
	return /** @type {LocalizedString} */ ("Nothing to drag")
});